module.exports = __webpack_public_path__ + "static/media/side-effects-header-image.75df8487.jpg";